import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const { reducer, actions } = createSlice({
    name: "comprobante",
    initialState: {
        items: {},
    },
    reducers: {
        refresh(state, action) {
            state.items = {};
            action.payload.forEach((item) => (state.items[item.id] = item));
        },
        update(state, action) {
            let payload = _.isArray(action.payload) ? action.payload : [action.payload];
            payload.forEach((item) => (state.items[item.id] = item));
        },
        delete(state, action) {
            delete state.items[action.payload.id];
        },
    },
});

export { actions as comprobanteActions };
export { reducer as comprobanteReducer };
